import React, { useState } from "react";
import { IPersonFormData } from "../../dtos.d";
import { showToast } from "../../../../../../components/CustomToast";
import { OutlinedInput } from "../../../../../../components/OutlinedInput";
import { SolidButton } from "../../../../../../components/SolidButton";
import { FiArrowRight } from "react-icons/fi";
import { FloatingSelect } from "../../../../../../components/FloatingSelect";
import {
  Container,
  SectionTitle,
  InputGroup,
  Row,
  FlexInput,
  Footer,
} from "./styles";

const celularMask = (value: string) => {
  return value
    .replace(/\D/g, "")
    .replace(/^(\d{2})(\d)/g, "($1) $2")
    .replace(/(\d)(\d{4})$/, "$1-$2")
    .substring(0, 15);
};

const cpfMask = (value: string) => {
  return value
    .replace(/\D/g, "")
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d{1,2})/, "$1-$2")
    .replace(/(-\d{2})\d+?$/, "$1")
    .substring(0, 14);
};

interface StepPersonalDataProps {
  personFormData: IPersonFormData;
  setPersonFormData: React.Dispatch<React.SetStateAction<IPersonFormData>>;
  nextStep: () => void;
  loading: boolean;
}

export function StepPersonalData({
  personFormData,
  setPersonFormData,
  nextStep,
  loading,
}: StepPersonalDataProps) {
  const [errors, setErrors] = useState<any>({});

  const handleChange = (field: keyof IPersonFormData, value: any) => {
    setPersonFormData((prev) => ({ ...prev, [field]: value }));
    if (errors[field]) setErrors((prev: any) => ({ ...prev, [field]: "" }));
  };

  const validateAndProceed = () => {
    const newErrors: any = {};
    const d = personFormData;

    if (!d.name || d.name.trim().length < 3) newErrors.name = "Nome obrigatório";
    if (!d.cpf || d.cpf.length < 14) newErrors.cpf = "CPF inválido";
    if (!d.expertise) newErrors.expertise = "Selecione uma formação";
    if (d.expertise !== "Técnico em Imobilização" && (!d.professional_number || d.professional_number.trim().length === 0)) {
      newErrors.professional_number = "Conselho obrigatório para esta formação";
    }
    if (!d.email || !/^\S+@\S+\.\S+$/.test(d.email)) newErrors.email = "E-mail inválido";
    if (!d.cellphone || d.cellphone.length < 14) newErrors.cellphone = "Telefone inválido";

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      showToast({ type: "error", message: "Preencha todos os campos obrigatórios corretamente." });
      return;
    }

    nextStep();
  };

  return (
    <Container>
      <SectionTitle>Dados do Participante</SectionTitle>
      
      <InputGroup>
        <Row>
          <FlexInput flex={2}>
            <OutlinedInput
              inputName="name"
              label="Nome completo"
              handleChange={(val) => handleChange("name", val)}
              value={personFormData.name}
              error={errors.name}
            />
          </FlexInput>
          <FlexInput flex={1}>
            <OutlinedInput
              inputName="cpf"
              label="CPF"
              handleChange={(val) => handleChange("cpf", cpfMask(val))}
              value={personFormData.cpf}
              error={errors.cpf}
            />
          </FlexInput>
        </Row>

        <Row>
          <FlexInput>
            <FloatingSelect
              label="Formação Profissional"
              value={personFormData.expertise || ""}
              onChange={(e) => handleChange("expertise", e.target.value)}
              error={errors.expertise}
            >
              <option value="" disabled hidden></option>
              <option value="Fisioterapeuta">Fisioterapeuta</option>
              <option value="Médico Ortopedista">Médico Ortopedista</option>
              <option value="Médico Reumatologista">Médico Reumatologista</option>
              <option value="Técnico em Imobilização">Técnico em Imobilização</option>
              <option value="Terapeuta Ocupacional">Terapeuta Ocupacional</option>
            </FloatingSelect>
          </FlexInput>
          <FlexInput>
            <OutlinedInput
              inputName="professional_number"
              label={personFormData.expertise === "Técnico em Imobilização" ? "Nº do Registro (Opcional)" : "Nº do Conselho/Registro Profissional"}
              handleChange={(val) => handleChange("professional_number", val)}
              value={personFormData.professional_number}
              error={errors.professional_number}
            />
          </FlexInput>
        </Row>

        <Row>
          <FlexInput flex={2}>
            <OutlinedInput
              inputName="email"
              label="E-mail (acesso à plataforma)"
              handleChange={(val) => handleChange("email", val)}
              value={personFormData.email}
              error={errors.email}
            />
          </FlexInput>
          <FlexInput flex={1}>
            <OutlinedInput
              inputName="cellphone"
              label="Telefone (WhatsApp)"
              handleChange={(val) => handleChange("cellphone", celularMask(val))}
              value={personFormData.cellphone}
              error={errors.cellphone}
            />
          </FlexInput>
        </Row>
      </InputGroup>

      <Footer>
        <SolidButton
          text={<div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "8px" }}>Avançar <FiArrowRight /></div>}
          fullWidth
          buttonHeight={48}
          onClick={validateAndProceed}
          loading={loading}
          disabled={loading}
        />
      </Footer>
    </Container>
  );
}